import { GetServerSideProps } from 'next';

import { PageRoot } from '@/_pages/root/_pageModule/PageRoot';
import { PageRootExportedMode } from '@/_pages/root/_pageModule/PageRootExportedMode';
import { clientConfig } from '@/config/clientConfig';
import { appServerSideTranslations } from '@/shared/utilsServer/i18n/appServerSideTranslations';

export default clientConfig.isExported ? PageRootExportedMode : PageRoot;

export const getServerSideProps: GetServerSideProps = async ({ query, locale }) => {
  const _delegationRequestId = query.delegationRequestId;
  const delegationRequestId = Array.isArray(_delegationRequestId)
    ? _delegationRequestId[0]
    : _delegationRequestId;

  if (!delegationRequestId) {
    return {
      props: {
        beneficiaryJWT: (query?.beneficiarydata as string) || null,
        ...(await appServerSideTranslations(locale, ['welcome', 'signup', 'auth'])),
      },
    };
  }
  return {
    props: {
      delegationRequestId: delegationRequestId,
      beneficiaryJWT: (query?.beneficiarydata as string) || null,
      ...(await appServerSideTranslations(locale, ['welcome', 'signup'])),
    },
  };
};
